var _rect, _path, _path2, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckV1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 9.68419,
    height: 8.4,
    rx: 0.431887,
    stroke: "#2B323B",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13.3999H20V14.8137C20 14.8951 19.9526 14.9691 19.8787 15.0033L19.2959 15.2722C18.9601 15.4272 18.688 15.6933 18.5256 16.0256V16.0256C18.3853 16.3126 18.0938 16.4946 17.7743 16.4946H5.94349C4.87013 16.4946 4 15.6245 4 14.5512V13.3999Z",
    stroke: "#2B323B",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6846 6.76855H16.8529C17.2962 6.76855 17.6665 7.1063 17.7071 7.54772L17.7392 7.89605C17.7637 8.16258 17.8346 8.42279 17.9486 8.66496V8.66496C18.2384 9.28045 18.7858 9.73611 19.4436 9.90947L19.6044 9.95185C19.8377 10.0133 20.0003 10.2243 20.0003 10.4656V13.4001H13.6846V6.76855Z",
    stroke: "#2B323B",
    strokeWidth: 1.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.97795,
    cy: 17.25,
    rx: 1.71428,
    ry: 1.75,
    fill: "white",
    stroke: "#2B323B",
    strokeWidth: 1.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.6615,
    cy: 17.25,
    rx: 1.71428,
    ry: 1.75,
    fill: "white",
    stroke: "#2B323B",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckV1);
export default __webpack_public_path__ + "static/media/truck-v1.5557b6fa95b4cc93387d63d6899bc3b0.svg";
export { ForwardRef as ReactComponent };